import { render, staticRenderFns } from "./TwoTabsPage.vue?vue&type=template&id=34a6ddde&scoped=true"
import script from "./TwoTabsPage.vue?vue&type=script&lang=js"
export * from "./TwoTabsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a6ddde",
  null
  
)

export default component.exports